import BlogSearch from './BlogSearch'

export default BlogSearch
